import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/Index'
import AwardList from '@/page/awardList'
import WxScan from '@/page/wxScan'

Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/awardList',
    name: 'AwardList',
    component: AwardList
  },
  {
    path: '/wxScan',
    name: 'WxScan',
    component: WxScan
  }
]
const router =  new Router({
  routes
})

let isRest = false;
/* 通过路由开发定制需求 */
if (!isRest && window.__p_routes && typeof window.__p_routes === 'function') {
  isRest = true;
  window.__p_routes(routes, router);
}
window.resetRouter = function (restFn) {
  !isRest && (isRest = true,restFn(routes, router));
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js